<div id="quickActions">
  <ul>
    <li>
      <button [disabled]="!(canRenewPostTreatment$ | async)" (click)="renewPostTreatment()" class="quickActionIcon">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_addTime"></span>
        <span class="quickActionLabel">{{ 'agent:contact.post_treatment.renew' | translate }}</span>
        <span class="nodisplay">{{ 'agent:contact.post_treatment.renew' | translate }}</span>
      </button>
    </li>
    <li>
      <button [disabled]="!(canFinishQualification$ | async)" (click)="finishQualification()" class="quickActionIcon">
        <span aria-hidden="true" class="quickActionIconBg cng-ico_annuler"></span>
        <span class="quickActionLabel">{{ 'agent:contact.actions.finish' | translate }}</span>
        <span class="nodisplay">{{ 'agent:contact.actions.finish' | translate }}</span>
      </button>
    </li>
  </ul>
</div>
